<template>
  <div @click="routeClick" :class="['block', color]" :title="title" />
</template>

<script>
import db from "../db.js";
import util from "../util.js";

export default {
  name: "block",
  props: {
    block: Object,
    blockId: String,
    categoryId: String,
    customDate: String,
    color: String,
  },
  data() {
    return {
      lastClick: 0,
    };
  },
  computed: {
    title() {
      // TODO - Toggle this so it's all relative to the current day being viewed
      //        Maybe we move this to a util so we don't have to pass the date down here? Or pull from route...
      let m = moment(this.block.ts);
      return m.calendar();
    },
  },
  // mounted() {
  //   // FIXME - THIS IS A HACK, DO THIS RIGHT, PLEASE!
  //   Vue.nextTick(() => this.$el.style = "");
  // },
  methods: {
    routeClick(e) {
      const ts = Date.now();
      // WILL BREAK ONCE WE ARE ONLY USING A SINGLE BLOCK COMPONENT?
      let isNewBlock = ts - this.block.ts <= 2000;
      let isBlockRun = ts - this.lastClick <= 1000 && ts - this.block.ts <= 5000;
      if (isNewBlock || isBlockRun) {
        // BLOCKRUNNNN!!!!
        this.addBlock();
      } else {
        this.removeBlock();
      }
      this.lastClick = ts;
    },
    addBlock() {
      let date = this.customDate.length ? this.customDate : util.getCurrentDay();
      db.addBlock(this.categoryId, date);
    },
    removeBlock() {
      let date = this.customDate.length ? this.customDate : util.getCurrentDay();
      db.removeBlock(this.categoryId, this.blockId, date);
    },
  },
};
</script>

<style>
.block {
  height: 1rem;
  width: 1rem;
  margin: 0.25rem;
  list-style: none;
  display: inline-block;
  border: 1px solid #333;
}

/* BLOCK COLORS */
.block.red {
  background-color: #ff3a24;
}

.block.orange {
  background-color: #e67e22;
}

.block.yellow {
  background-color: #f1c40f;
}

.block.green {
  background-color: #2ecc71;
}

.block.turquoise {
  background-color: #1abc9c;
}

.block.blue {
  background-color: #3498db;
}

.block.purple {
  background-color: #9b59b6;
}

.block.pink {
  background-color: #ff2470;
}

.block.lightGray {
  background-color: #ecf0f1;
}

.block.darkGray {
  background-color: #95a5a6;
}

.block.black {
  background-color: #34495e;
}

.block.white {
  background-color: #fff;
}

.block.new {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// Block.vue?6ef8788e